export namespace AlertRun {
  export type Request = {
    vertical?: string;
    user_id: string;
    environment: string;
    alert_id: string;
  }
  export type Response = unknown;
}
